<template>
    <div class="stone-expanded-row row">
        <div class="col-md-4">
            <div ref="imageIframe">
                <div class="stone-image-div" v-if="selectedStone.diamond">
                    <img class="w-100 rounded-border" v-if="selectedStone.diamond.image && !selectedStone.diamond.video"
                        :src="selectedStone.diamond.image" />
                    <iframe class="rounded-border" scrolling="no" v-if="selectedStone.diamond.video"
                        :height="iframeSize" :width="iframeSize" :src="selectedStone.diamond.video"></iframe>
                    <img class="w-100 rounded-border"
                        v-if="!selectedStone.diamond.image && !selectedStone.diamond.video"
                        src="../assets/diamond_placeholder.jpeg" />
                </div>
            </div>
        </div>

        <div class="col-md-8">
            <div class="row m-0">
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.shape') }}</span>
                    <span class="feature-value">{{ selectedStone.diamond.certificate.shape }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.carat') }}</span>
                    <span class="feature-value">{{ selectedStone.diamond.certificate.carats }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.cut') }}</span>
                    <span class="feature-value">{{ $t('stones.quality.' + selectedStone.diamond.certificate.cut)
                    }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.color') }}</span>
                    <span class="feature-value">{{ selectedStone.color }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.clarity') }}</span>
                    <span class="feature-value">{{ selectedStone.diamond.certificate.clarity }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.polish') }}</span>
                    <span class="feature-value">{{ $t('stones.quality.' + selectedStone.diamond.certificate.polish)
                    }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.symmetry') }}</span>
                    <span class="feature-value">{{ $t('stones.quality.' + selectedStone.diamond.certificate.symmetry)
                    }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.fluorescence') }}</span>
                    <span class="feature-value">{{ $t('stones.fluorescence.' + selectedStone.diamond.certificate.floInt)
                    }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.measurements') }}</span>
                    <span class="feature-value">{{ getMeasurements() }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.lwRatio') }}</span>
                    <span class="feature-value">{{
                        selectedStone.diamond.certificate.length / selectedStone.diamond.certificate.width |
                        number('0.00')
                    }}</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.table') }}</span>
                    <span class="feature-value">{{ selectedStone.diamond.certificate.table | number('0.00') }}%</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.depth') }}</span>
                    <span class="feature-value">{{
                        selectedStone.diamond.certificate.depthPercentage | number('0.00')
                    }}%</span>
                </div>
                <div class="col-6 col-md-4">
                    <span class="feature-label">{{ $t('stones.certificateLab') }}</span>
                    <span class="feature-value">{{ selectedStone.diamond.certificate.lab +
                        (selectedStone.diamond.certificate.pdfUrl ? " " + selectedStone.diamond.certificate.certNumber :
                            "") }}</span>
                </div>
            </div>
            <div class="row m-0">
                <div class="col-md-6 d-flex">
                    <button class="btn more-info-btn" v-if="selectedStone.diamond.certificate.pdfUrl"
                        @click="openCertificate(selectedStone.diamond.certificate.pdfUrl)">
                        {{ $t("stones.certificateLab") | uppercase }}
                    </button>
                </div>
                <div class="col-md-6">
                    <div class="price-div" v-if="!buildYourJewelMode || showBuildYourJewelPrice()">
                        <div class="w-100 text-left">
                            <span class="discount"
                                v-if="retailPerc == 1 && credential.apiEncryptedUse && !showBuildYourJewelPrice()">
                                {{ $t("stones.discount") }}
                            </span>
                            <span v-if="buildYourJewelMode">{{ $t("build_your_jewel.jewel_price") }}</span>
                            <span v-if="!buildYourJewelMode">{{ $t("jewelValue") }}</span>
                        </div>
                        <div class="w-100 text-right">
                            <span class="discount"
                                v-if="retailPerc == 1 && credential.apiEncryptedUser && !showBuildYourJewelPrice()">{{
                                    (-Math.abs(selectedStone.discount)) / 100 + '%' }}</span>
                            <span v-if="buildYourJewelMode">{{ $t("from") + ' ' }} {{ selectedStone.buildYourJewelPrice
                                *
                                retailPerc * vat |
                                currency }}</span>
                            <span v-if="!buildYourJewelMode">{{ selectedStone.cartItem.singleAmount * retailPerc * vat |
                                currency }}</span>
                        </div>
                    </div>
                    <div class="planned-shipment" v-if="!buildYourJewelMode">
                        <div class="w-100 text-left">{{ $t("plannedShipment") }}</div>
                        <div class="w-100 text-right">{{ selectedStone.cartItem.deliveryDate }}</div>
                    </div>
                    <button :class="[row.addedToBasket ? 'btn-secondary-' + theme : 'btn-primary-' + theme]"
                        v-if="!buildYourJewelMode" :disabled="row.addedToBasket" class="btn add-to-cart-btn"
                        @click="addToBasket">
                        <span class v-if="row.addedToBasket">{{
                            $t("addedToBasket")
                        }}</span>
                        <span class v-else>{{ $t("addToBasket") }}
                        </span>
                    </button>
                    <button v-if="buildYourJewelMode" class="btn add-to-cart-btn" @click="selectStone(selectedStone)">{{
                        $t("build_your_jewel.selectStone") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Vue from "vue";

export default {
    name: "StoneListExpandedRow",
    props: {
        row: Object
    },
    data: function () {
        return {
            iframeSize: 0,
        }
    },
    computed: mapState({
        theme: (state) => state.config.theme,
        selectedStone: (state) => state.stones.selectedStone,
        buildYourJewelMode: (state) => state.buildYourJewel.buildYourJewelMode,
        retailPerc: (state) => state.detail.retailPerc,
        vat: (state) => state.detail.vat,
        credential: (state) => state.config.credential
    }),
    methods: {
        ...mapGetters("buildYourJewel", ["showBuildYourJewelPrice"]),
        ...mapActions("buildYourJewel", [
            "selectStone",
        ]),
        refreshImageIframeSize: function (row) {
            this.$nextTick(() => {
                const imageDiv = this.$refs.imageIframe?.querySelector(".stone-image-div");
                if (row.diamond?.video && imageDiv) {
                    const width = imageDiv.clientWidth;
                    this.iframeSize = width;
                    this.selectedStone.diamond.video = row.diamond.video.replace(/\d+\/\d+/, `${width}/${width}`)
                }
            });
        },
        addToBasket: function () {
            Vue.set(this.row, 'addedToBasket', true);
            Vue.addToBasket(this.selectedStone.cartItem);
        },
        openCertificate(url) {
            var popUpObj = window.open(`${process.env.VUE_APP_BASE_URL}/stone-certificate/pdf?url=` + url, "CertificatePopUp", "width=auto,height=auto");
            popUpObj.focus();
        },
        formatNumberWithTwoDecimals(number) {
            return this.$options.filters.number(parseFloat(number), '0.00');
        },
        getMeasurements() {
            return this.formatNumberWithTwoDecimals(this.selectedStone.diamond.certificate.length) + 'x' +
                this.formatNumberWithTwoDecimals(this.selectedStone.diamond.certificate.width) + 'x' +
                this.formatNumberWithTwoDecimals(this.selectedStone.diamond.certificate.depth);
        }
    },
    mounted() {
        this.refreshImageIframeSize(this.selectedStone);
        window.addEventListener('resize', () => {
            this.refreshImageIframeSize(this.selectedStone);
        });
    }
}

</script>

<style lang="scss" scoped>
.stone-expanded-row {
    background-color: white;
    padding: 15px;

    .feature-label {
        display: block;
        text-align: left;
        font-weight: bold;
    }

    .feature-value {
        display: block;
        text-align: left;
        margin-bottom: 15px;
    }

    .more-info-btn {
        width: 100%;
        background-color: #ddd !important;
        margin-top: auto;
    }

    .add-to-cart-btn {
        width: 100%;
        color: white !important;
        text-transform: uppercase;
    }

    .price-div {
        display: flex;
        font-size: 18px;
        font-weight: bold;
        border: 2px solid var(--primary-color-1);
        padding: 10px 15px;
        margin-top: 10px;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    .discount {
        display: block;
        color: green;
        font-size: 14px;
    }

    .text-left {
        margin-top: auto;
    }

    .rounded-border {
        border-radius: 10px;
    }

    .planned-shipment {
        display: flex;
        padding: 0px 15px 5px 15px;
        border-bottom: 1px solid var(--secondary-color-1);
        margin-bottom: 5px;
        font-size: 12px;
    }

    .btn-primary-1 {
        border-radius: 5px;
        background-color: var(--primary-color-1) !important;
        color: #fff !important;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    }

    .btn-secondary-1 {
        border-radius: 5px;
        color: #fff !important;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    }

    .btn-primary-2 {
        border-radius: 5px;
        background-color: var(--primary-color-1) !important;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

        span {
            color: var(--gray-label-1) !important;
        }
    }

    .btn-secondary-2 {
        border-radius: 5px;
        background-color: var(--primary-color-1) !important;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

        span {
            color: var(--gray-label-1) !important;
        }
    }

    .stone-image-div {
        aspect-ratio: 1/1;
        width: 100%;
    }

}
</style>